window.addEventListener('DOMContentLoaded', () => {
    let easter_config = document.querySelector('.section-easter-collection').getAttribute('data-easter-settigns');
    easter_config = JSON.parse(easter_config);
    let swiper_config = {
      slidesPerColumn: easter_config.isColumns ? 3 : 1,
      autoplay: !easter_config.isAutoplay ? { delay: 3000, disableOnInteraction: false } : false,
    };
    new Swiper('#easter-collection-swiper', {
      ...swiper_config,
      slidesPerView: 1,
      spaceBetween: 20,
      navigation: {
        nextEl: '.button-next-easter-collection-swiper',
        prevEl: '.button-prev-easter-collection-swiper',
      },
      breakpoints: {
        //当swiper宽度大于等于768
        769: {
          slidesPerView: 3,
          spaceBetween: 20,
          slidesPerColumn: 1,
        },
        1200: {
          slidesPerView: 4,
          slidesPerColumn: 1,
          spaceBetween: 20,
        },
      },
    });
  });